import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-maintenance-print-formats",
  templateUrl: "./maintenance-print-formats.component.html",
  styleUrls: ["./maintenance-print-formats.component.sass"],
})
export class MaintenancePrintFormatsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
